import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { allowedEntities } from "../utils/TextMessage";
import { useContext, useEffect } from "react";
import { AppContext } from "../context/AppContext";
import { KEY_NAME } from "../utils/KeyName";
import LegacyRedirector from "./LegacyRedirector";
import PageNotFound from "../pages/pageNotFound/PageNotFound";

// export const entityName = () => {
//   const { entityType } = useParams();
//   return entityType;
// };

const RouteGuard = () => {
  const { changeEntityName } = useContext(AppContext);
  // const allowedEntities = [
  //   KEY_NAME.FUNDER,
  //   KEY_NAME.PUBLISHER,
  //   KEY_NAME.INSTITUTION,
  // ];
  const { entityType } = useParams();
  const location = useLocation();

  useEffect(() => {
    if (allowedEntities.includes(entityType)) {
      changeEntityName(entityType);
    }
  }, []);

  if (entityType === "page-not-found") {
    return <PageNotFound />;
  }

  if (!allowedEntities.includes(entityType)) {
    // return <Navigate to="/" replace />;
    // return <Navigate to="/page-not-found" replace />;
    return (
      <LegacyRedirector assumedType="funders" explicitShortName={entityType} />
    );
  }

  if (location.pathname.includes(entityType) && location.hash.endsWith("@")) {
    // Pass "masked" manually so LegacyRedirector knows exactly how to extract the hash!
    return (
      <LegacyRedirector assumedType={entityType} explicitShortName="masked" />
    );
  }

  return <Outlet />;
};

export default RouteGuard;
